import { render, staticRenderFns } from "./JudicialCase.vue?vue&type=template&id=8daa9ce0"
import script from "./JudicialCase.vue?vue&type=script&lang=js"
export * from "./JudicialCase.vue?vue&type=script&lang=js"
import style0 from "./JudicialCase.vue?vue&type=style&index=0&id=8daa9ce0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports